<template>
  <div class="errors-info-wrapper spacex-8">
    <CheckIcon class="icon-20px" />
    <span class="text-sm">{{ $t('All correct') }}</span>
  </div>
</template>

<script>
  import CheckIcon from '@/assets/icons/success.svg';

  export default {
    name: 'AllCorrect',
    components: {
      CheckIcon,
    },
  };
</script>
